import { render, staticRenderFns } from "./AvatarBadgePosition.vue?vue&type=template&id=10d17dcc"
import script from "./AvatarBadgePosition.vue?vue&type=script&lang=js"
export * from "./AvatarBadgePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports